// extracted by mini-css-extract-plugin
export default {"empty":"notFound_empty__SZ+2x","tile":"notFound_tile__ybPXz","title":"notFound_title__g6tMM","text":"notFound_text__HpERM","action":"notFound_action__Zx25H"};